import * as React from "react";
import { NonIdealState } from "@blueprintjs/core";
import { useParams } from "react-router-dom";
import { useAuthState } from "../../../context/auth";
import { isFybrAdminUser } from "../adminRoles";
import { useOrganizationAdminGate } from "../useOrganizationAdminGate";
import { OrganizationSettingsPage } from "../OrganizationSettings/OrganizationSettingsPage";

export default function AdminOrganizationSettings() {
  const gate = useOrganizationAdminGate();
  const { organization_id } = useParams<{ organization_id: string }>();
  const { currentUser } = useAuthState();
  const organizationId = Number(organization_id);

  if (gate === "pending") return null;
  if (gate === "denied") {
    return (
      <NonIdealState
        icon="lock"
        title="Not authorized"
        description="Organization admin access is required to manage settings."
      />
    );
  }

  const isFybrAdmin = isFybrAdminUser(currentUser);
  if (
    !isFybrAdmin &&
    currentUser != null &&
    currentUser.organization_id !== organizationId
  ) {
    return (
      <NonIdealState
        icon="lock"
        title="Not authorized"
        description="You can only manage settings for your own organization."
      />
    );
  }

  return (
    <OrganizationSettingsPage
      organizationId={organizationId}
      canManageProvisionedResources={isFybrAdmin}
    />
  );
}
